module.exports = __webpack_public_path__ + "img/vita.a6eea2a3.svg";